import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  _id: string;
  lrn: string;
  eori: string;
}

export const useCheckImporterEori = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ _id, lrn, eori }: HookProps): Promise<boolean> => {
      const { isValid } = await request({
        path: `declarations/${lrn}/check-importer-eori`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { eori },
      });

      return isValid;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables._id] });
      toast.success('Declaration changes were saved!');
    },
    onError: (error) => {
      showErrorToast(error, `Error checking eori!`);
    },
  });
};
